module.exports = "/lucky-balls/img/combos/81-.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos/81-.png
// module id = 1005
// module chunks = 0